import { render, staticRenderFns } from "./PathwayDetail.vue?vue&type=template&id=00a54b60&scoped=true&"
import script from "./PathwayDetail.vue?vue&type=script&lang=js&"
export * from "./PathwayDetail.vue?vue&type=script&lang=js&"
import style0 from "./PathwayDetail.vue?vue&type=style&index=0&id=00a54b60&lang=scss&scoped=true&"
import style1 from "./PathwayDetail.vue?vue&type=style&index=1&id=00a54b60&scoped=true&lang=css&"
import style2 from "./PathwayDetail.vue?vue&type=style&index=2&id=00a54b60&scoped=true&lang=css&"
import style3 from "./PathwayDetail.vue?vue&type=style&index=3&id=00a54b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a54b60",
  null
  
)

export default component.exports